import { literal, struct } from 'io-ts/lib/Decoder';

import { DimensionLine } from '../scale/DimensionLine';

/**
 * UI -> BE: the external dimensions as confirmed by the estimator.
 *
 * The pair Brain Engine sent on the page state, echoed back with the corrected
 * `calculatedLength` on each line, exactly as the Scale step echoes its own
 * calibration lines.
 */
export const ExternalDimensionsConfirmed = struct({
	type: literal('external-dimensions-confirmed'),
	xDimension: DimensionLine,
	yDimension: DimensionLine,
});
